import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const NetWorthFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 17H4C3.448 17 3 16.552 3 16V4C3 3.448 3.448 3 4 3H16C16.552 3 17 3.448 17 4V16C17 16.552 16.552 17 16 17Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.41421 8.58579C10.1953 9.36683 10.1953 10.6332 9.41421 11.4142C8.63317 12.1953 7.36684 12.1953 6.58579 11.4142C5.80474 10.6332 5.80474 9.36684 6.58579 8.58579C7.36683 7.80474 8.63316 7.80474 9.41421 8.58579"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8.5H15"
        stroke={theme.colors.primary.c500}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 11.5H15"
        stroke={theme.colors.primary.c500}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NetWorthFilterIcon;
